var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* パスワードリセット画面 */
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Block from '../molecules/Block';
import Text from '../molecules/Text';
import Annotation from '../atoms/Annotation';
import CenterButton from '../atoms/CenterButton';
import axios from '../axios';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import { handleBrowzerBack } from '../BrowzerBack';
import LoadingModal from '../organisms/LoadingModal';
import { jumpUrl } from '../Common';
var PasswordReset = function () {
    // パスワードリセットメール情報のState
    // 処理結果通知ダイアログ
    var _a = useState(false), show = _a[0], setShow = _a[1];
    var handleShow = function () { return setShow(true); };
    var handleClose = function () { return setShow(false); };
    var successDialogMessage = 'パスワードリセットの案内メールを送付しました。';
    // メールアドレス
    var _b = useState(''), email = _b[0], setResetMail = _b[1];
    // 表示メッセージ
    var _c = useState(), send_reset_mail_message = _c[0], setSendResetMailResult = _c[1];
    var _d = useState('init'), dialog_message = _d[0], setDialogMessage = _d[1];
    // HTTPステータスコード
    var _e = useState(0), status_code = _e[0], setStatusCode = _e[1];
    // Ajax通信中フラグ
    var _f = useState(false), is_connecting = _f[0], setIsConnecting = _f[1];
    //ローディング画面表示状態
    var _g = useState(false), is_loading = _g[0], setIsLoading = _g[1];
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
    }, []);
    // パスワード変更ボタンのクリックイベントを定義
    var handleClick = function () {
        // パスワードリセットメール情報をStateへセット
        var mail_info = { email: email };
        var sendResetMail = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        if (is_connecting) {
                            return [2 /*return*/];
                        }
                        //ローディング画面表示
                        setIsLoading(true);
                        setIsConnecting(true);
                        return [4 /*yield*/, axios.post('/applicant/send_mail', mail_info)];
                    case 1:
                        response = _a.sent();
                        setSendResetMailResult(response.data.message);
                        setDialogMessage(successDialogMessage);
                        setStatusCode(response.status);
                        // ダイアログ表示
                        handleShow();
                        setIsConnecting(false);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        // 失敗
                        jumpUrl(error_1.response.data.url);
                        setSendResetMailResult(error_1.response.data.message);
                        setStatusCode(error_1.response.status);
                        setIsConnecting(false);
                        return [3 /*break*/, 4];
                    case 3:
                        //ローディング画面非表示
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // パスワードリセットメール送信
        sendResetMail();
    };
    // 完了ダイアログでOKをクリックしたらログイン画面へ遷移
    var handleClickOk = function () {
        handleClose();
        location.replace("" + location.origin + process.env.MIX_MOCK_URL + "/mypage/login");
    };
    /**
     * 戻るボタンをクリックする
     */
    var handleClickReturn = function () {
        location.replace("" + location.origin + process.env.MIX_MOCK_URL + "/mypage/login");
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-5" }),
        React.createElement(Block, { label: "\u30D1\u30B9\u30EF\u30FC\u30C9\u30EA\u30BB\u30C3\u30C8", content: React.createElement(React.Fragment, null,
                React.createElement(Annotation, { text: "\u3054\u767B\u9332\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u30D1\u30B9\u30EF\u30FC\u30C9\u30EA\u30BB\u30C3\u30C8\u306E\u6848\u5185\u30E1\u30FC\u30EB\u3092\u9001\u4ED8\u3057\u307E\u3059\u3002" }),
                React.createElement("div", { className: "mt-3" }),
                React.createElement("div", null,
                    React.createElement(Text, { id: "email", label: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9", value: email, placeholder: "example@example.com", handleChange: function (event) {
                            return setResetMail(event.target.value);
                        }, disabled: false, maxlength: 200 })),
                React.createElement("div", { className: "mt-3" }),
                React.createElement(Row, { className: "d-flex align-items-center justify-content-center" },
                    React.createElement(Col, null),
                    send_reset_mail_message !== undefined &&
                        // パスワードリセットメールの送信失敗
                        status_code !== 200 && (
                    // 失敗
                    React.createElement(Col, { md: 9, className: "alert-danger alert-danger-custom" }, send_reset_mail_message)))) }),
        React.createElement(CenterButton, { label: "\u30EA\u30BB\u30C3\u30C8\u30E1\u30FC\u30EB\u9001\u4FE1", handleClick: handleClick }),
        React.createElement("div", { className: "mt-4 text-center" },
            React.createElement(Button, { variant: "main-color", className: "return-button", size: "lg", onClick: handleClickReturn }, "\u623B\u308B")),
        React.createElement(Modal, { className: "d-flex modal-dialog-centered", show: show, onHide: handleClose, animation: false },
            React.createElement(Modal.Header, { closeButton: true },
                React.createElement(Modal.Title, { className: "dialog-title" }, "\u30E1\u30FC\u30EB\u9001\u4FE1\u7D50\u679C")),
            React.createElement(Modal.Body, { className: "dialog-body" }, dialog_message),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { variant: "secondary", onClick: handleClickOk }, "OK"))),
        React.createElement(LoadingModal, { show: is_loading })));
};
if (document.getElementById('password-reset-imp')) {
    ReactDOM.render(React.createElement(PasswordReset, null), document.getElementById('password-reset-imp'));
}
